import React from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { CalendarDaysIcon, PlusIcon, Trash2Icon } from 'lucide-react';

interface EventRoomSectionProps {
  readOnly?: boolean;
}

const EventRoomSection = ({ readOnly = false }: EventRoomSectionProps) => {
  const { register, setValue, watch } = useFormContext();
  const eventRooms = watch('services.eventRooms', []);
  
  const handleAddEventRoom = () => {
    if (!readOnly) {
      setValue('services.eventRooms', [
        ...eventRooms,
        { name: '', capacity: 0 }
      ]);
    }
  };

  const handleRemoveEventRoom = (index: number) => {
    if (!readOnly) {
      const newEventRooms = eventRooms.filter((_, i) => i !== index);
      setValue('services.eventRooms', newEventRooms);
    }
  };

  const hasEventRooms = eventRooms.length > 0;

  return (
    <div className="form-group">
      <div className="flex flex-col space-y-2">
        <Label className="form-label flex items-center gap-2">
          <CalendarDaysIcon size={16} />
          Salones de eventos
        </Label>
        
        <div className="space-y-4 pl-0 pt-4">
          {eventRooms.map((_, index) => (
            <div key={index} className="grid grid-cols-1 sm:grid-cols-4 gap-4 items-end">
              <div className="form-group">
                <Label className="form-label">Nombre del salón</Label>
                <Input 
                  {...register(`services.eventRooms.${index}.name`)}
                  className="form-input"
                  type="text"
                  placeholder="Nombre del salón"
                  disabled={readOnly}
                />
              </div>
              <div className="form-group">
                <Label className="form-label">Capacidad (personas)</Label>
                <Input 
                  {...register(`services.eventRooms.${index}.capacity`, { valueAsNumber: true })}
                  className="form-input"
                  type="number"
                  min="1"
                  max="32767"
                  disabled={readOnly}
                />
              </div>
              {!readOnly && (
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  onClick={() => handleRemoveEventRoom(index)}
                  className="h-10 w-10"
                >
                  <Trash2Icon className="h-4 w-4 text-destructive" />
                </Button>
              )}
            </div>
          ))}
          
          {!readOnly && (
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleAddEventRoom}
              className="mt-2"
            >
              <PlusIcon className="h-4 w-4 mr-1" />
              Agregar salón
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventRoomSection;
